import { useContext } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Paper, Avatar, Table, TableHead, TableBody, TableRow, TableCell, Typography, Chip, Button, Link, Hidden, Grid } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { RolesContext } from '../RolesContext';
import { NavContext, NavRoutes } from '../../../../contexts';
import { ApplicationRoles } from '../../../../../helpers';
import PersonIcon from '@material-ui/icons/PersonOutlined';
import CloudIcon from '@material-ui/icons/CloudOutlined';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        overflow: 'hidden',
        marginTop: theme.spacing(4)
    },
    user: {
        display: 'flex',
        alignItems: 'center'
    },
    avatar: {
        marginRight: theme.spacing(1)
    },
    table: {

    },
    chip: {
        //padding: '0px',  
        margin: '2px'
    }
}));

const LinkRouter = props => <Link {...props} component={RouterLink} />;

export const UserList = (props) => {
    const classes: any = useStyles();
    const { getRouteTo } = useContext(NavContext)

    const {
        state,
        isRemovingFromRole,
        removeUserFromRole
    } = useContext(RolesContext);

    const removeUserClickHandler = async (user) => {
        await removeUserFromRole(user.externalKey, state.role.applicationRoleId);
    }

    return (
        <Paper className={classes.root}>
            <Hidden xsDown>
                <Table className={classes.table} arial-label="roles table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Full Name</TableCell>
                            {/*<TableCell>Email</TableCell>*/}
                            {state.role && state.role.name === 'AccountReceivable' ?
                                <TableCell>Companies</TableCell>
                                :
                                null
                            }
                            {state.role && state.role.name === 'LogisticCustomerService' ?
                                <TableCell>Business Category</TableCell>
                                :
                                null
                            }
                            {state.role && state.role.name === 'LogisticCustomerService' ?
                                <TableCell>Customer Groups</TableCell>
                                :
                                null
                            }
                            {state.role && state.role.name === 'LogisticCustomerService' ?
                                <TableCell>Countries</TableCell>
                                :
                                null
                            }
                            {state.role && state.role.name === ApplicationRoles.AOFOpener ?
                                <TableCell>Sales Group</TableCell>
                                :
                                null
                            }
                            {state.role && state.role.name === ApplicationRoles.AOFOpener ?
                                <TableCell>Business Category</TableCell>
                                :
                                null
                            }
                            {state.role && state.role.name === ApplicationRoles.AOFOpener ?
                                <TableCell>Companies</TableCell>
                                :
                                null
                            }
                            {state.role && state.role.name === ApplicationRoles.AOFOpener ?
                                <TableCell>Sales Organization</TableCell>
                                :
                                null
                            }
                            <TableCell align="right"></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            state.role &&
                            state.role.members &&
                            state.role.members.map((user, index: number): JSX.Element =>
                                <TableRow hover key={index}>
                                    <TableCell component="th" scope="row">
                                        <div className={classes.user}>
                                            <Avatar aria-label="recipe" className={classes.avatar}>
                                                <PersonIcon />
                                            </Avatar>

                                            {
                                                state.role.groupAADReference === null ?
                                                <Typography>
                                                    <LinkRouter key={index} color="textSecondary" to={getRouteTo(NavRoutes.Admin.EditUserInRole, [state.role.applicationRoleId, user.externalKey])}>
                                                        {user.displayName}
                                                    </LinkRouter>
                                                </Typography> :
                                                <Typography color="textSecondary">
                                                    {user.displayName}
                                                </Typography>
                                            }
                                        </div>
                                    </TableCell>

                                    {/*<TableCell>
                                        <Typography>
                                            {user.email || "(no mail)"}
                                        </Typography>
                                    </TableCell>*/}

                                    {
                                        state.role.name === 'AccountReceivable' ?
                                        <TableCell>
                                            {
                                                user &&
                                                user.companies.map((company, index) =>
                                                    <Chip
                                                        key={company}
                                                        label={company}
                                                        className={classes.chip}
                                                    />
                                                )
                                            }
                                        </TableCell> :
                                        null
                                    }

                                    {
                                        state.role.name === 'LogisticCustomerService' ?
                                        <TableCell>
                                            <Typography>
                                                {user.businessCategory || "(no BC)"}
                                            </Typography>
                                        </TableCell> :
                                        null
                                    }

                                    {
                                        state.role.name === 'LogisticCustomerService' ?
                                        <TableCell>
                                            {
                                                user &&
                                                user.customerGroups.map((cg, index: number): JSX.Element =>
                                                    <Chip
                                                        key={index}
                                                        label={cg}
                                                        className={classes.chip}
                                                    />
                                                )
                                            }
                                        </TableCell> :
                                        null
                                    }

                                    {
                                        state.role.name === 'LogisticCustomerService' ?
                                        <TableCell>
                                            {
                                                user &&
                                                user.countries.map((c, index: number): JSX.Element =>
                                                    <Chip
                                                        key={index}
                                                        label={c}
                                                        className={classes.chip}
                                                    />
                                                )
                                            }
                                        </TableCell> :
                                        null
                                    }

                                    {
                                        state.role.name === ApplicationRoles.AOFOpener ?
                                        <TableCell>
                                            <Typography>
                                                {user.salesGroup || "(no SG)"}
                                            </Typography>
                                        </TableCell> :
                                        null
                                    }

                                    {
                                        state.role.name === ApplicationRoles.AOFOpener ?
                                        <TableCell>
                                            <Typography>
                                                {user.businessCategory || "(no BC)"}
                                            </Typography>
                                        </TableCell> :
                                        null
                                    }

                                    {
                                        state.role.name === ApplicationRoles.AOFOpener ?
                                        <TableCell>
                                            {
                                                user && 
                                                user.companies.map((company, index: number): JSX.Element =>
                                                    <Chip
                                                        key={index}
                                                        label={company}
                                                        className={classes.chip}
                                                    />
                                                )
                                            }
                                        </TableCell> :
                                        null
                                    }

                                    {
                                        state.role.name === ApplicationRoles.AOFOpener ?
                                        <TableCell>
                                            {
                                                user &&
                                                user.salesOrganization.map((s, index: number): JSX.Element =>
                                                    <Chip
                                                        key={index}
                                                        label={s}
                                                        className={classes.chip}
                                                    />
                                                )
                                            }
                                        </TableCell> :
                                        null
                                    }

                                    <TableCell align="right">
                                        {
                                            state.role.groupAADReference === null ?
                                            <Button
                                                color="secondary"
                                                size="small"
                                                variant="contained"
                                                disabled={isRemovingFromRole}
                                                onClick={() => removeUserClickHandler(user)}
                                            >
                                                Remove
                                            </Button> :
                                            <Chip
                                                icon={<CloudIcon />}
                                                label="Active Directory"
                                                variant="outlined"
                                            />
                                        }
                                    </TableCell>
                                </TableRow>
                            )
                        }
                    </TableBody>
                </Table>
            </Hidden>
            <Hidden smUp>
                <Table className={classes.table} arial-label="roles table">
                    <TableHead>
                        <TableRow>
                            {state.role.name === 'AccountReceivable' ?
                                <TableCell>Full Name and Companies</TableCell>
                                :
                                null
                            }
                            {state.role.name === 'LogisticCustomerService' ?
                                <TableCell>Full Name, Business Category, Customer Groups and Countries</TableCell>
                                :
                                null
                            }
                            {state.role.name === ApplicationRoles.AOFOpener ?
                                <TableCell>Full Name, Sales Group, Business Category, Companies and Sales Organization</TableCell>
                                :
                                null
                            }
                            {state.role.name !== 'AccountReceivable' &&
                                state.role.name !== 'LogisticCustomerService' &&
                                state.role.name !== ApplicationRoles.AOFOpener ?
                                <TableCell>Full Name</TableCell>
                                :
                                null
                            }
                            {
                            /*OLD LABELS*/
                                /*state.role.name === 'AccountReceivable' ?
                                <TableCell>Full Name, Email and Companies</TableCell>
                                :
                                null
                            }
                            {state.role.name === 'LogisticCustomerService' ?
                                <TableCell>Full Name, Email, Business Category, Customer Groups and Countries</TableCell>
                                :
                                null
                            }
                            {state.role.name !== 'AccountReceivable' && state.role.name !== 'LogisticCustomerService' ?
                                <TableCell>Full Name and Email</TableCell>
                                :
                                null
                            */}
                            {state.role.groupAADReference === null ? <TableCell align="right"></TableCell> : null}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {state.role && state.role.members && state.role.members.map((user, index) =>
                            <TableRow hover key={index}>
                                <TableCell component="th" scope="row">
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <Grid container justifyContent="space-between">
                                                <Grid item>
                                                    {state.role.groupAADReference === null ?
                                                        <Typography>
                                                            <LinkRouter key={index} color="textSecondary" to={getRouteTo(NavRoutes.Admin.EditUserInRole, [state.role.applicationRoleId, user.externalKey])}>
                                                                {user.displayName}
                                                            </LinkRouter>
                                                        </Typography>
                                                        :
                                                        <Typography color="textSecondary">
                                                            {user.displayName}
                                                        </Typography>
                                                    }
                                                </Grid>
                                                {state.role.groupAADReference === null ?
                                                    null
                                                    :
                                                    <Grid item>
                                                        <CloudIcon />
                                                    </Grid>
                                                }
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography variant="caption">
                                                {/*user.email || "(no mail)"*/}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} className={classes.chips}>
                                            {state.role.name === 'AccountReceivable' ?
                                                <Typography >
                                                    {user && user.companies.map((company, index) =>
                                                        <Chip
                                                            key={company}
                                                            label={company}
                                                            className={classes.chip} />)
                                                    }
                                                </Typography>
                                                :
                                                null
                                            }
                                        </Grid>
                                        <Grid item xs={12}>
                                            {state.role.name === 'LogisticCustomerService' ?
                                                <Typography>
                                                    {user.businessCategory || "(no BC)"}
                                                </Typography>
                                                :
                                                null
                                            }
                                        </Grid>
                                        <Grid item xs={12}>
                                            {state.role.name === 'LogisticCustomerService' ?
                                                <Typography>
                                                    {user && user.customerGroups.map((cg, index) =>
                                                        <Chip
                                                            key={cg}
                                                            label={cg}
                                                            className={classes.chip} />)
                                                    }
                                                </Typography>
                                                :
                                                null
                                            }
                                        </Grid>
                                        <Grid item xs={12}>
                                            {state.role.name === 'LogisticCustomerService' ?
                                                <Typography>
                                                    {user && user.countries.map((c, index) =>
                                                        <Chip
                                                            key={c}
                                                            label={c}
                                                            className={classes.chip} />)
                                                    }
                                                </Typography>
                                                :
                                                null
                                            }
                                        </Grid>

                                        <Grid item xs={12}>
                                            {state.role.name === ApplicationRoles.AOFOpener ?
                                                <Typography>
                                                    {user.salesGroup || "(no SG)"}
                                                </Typography>
                                                :
                                                null
                                            }
                                        </Grid>
                                        <Grid item xs={12}>
                                            {state.role.name === ApplicationRoles.AOFOpener ?
                                                <Typography>
                                                    {user.businessCategory || "(no BC)"}
                                                </Typography>
                                                :
                                                null
                                            }
                                        </Grid>
                                        <Grid item xs={12}>
                                            {state.role.name === ApplicationRoles.AOFOpener ?
                                                <Typography>
                                                    {user && user.companies.map((c, index) =>
                                                        <Chip
                                                            key={c}
                                                            label={c}
                                                            className={classes.chip} />)
                                                    }
                                                </Typography>
                                                :
                                                null
                                            }
                                        </Grid>
                                        <Grid item xs={12}>
                                            {state.role.name === ApplicationRoles.AOFOpener ?
                                                <Typography>
                                                    {user && user.salesOrganization.map((so, index) =>
                                                        <Chip
                                                            key={so}
                                                            label={so}
                                                            className={classes.chip} />)
                                                    }
                                                </Typography>
                                                :
                                                null
                                            }
                                        </Grid>
                                    </Grid>
                                </TableCell>
                                {state.role.groupAADReference === null ?
                                    <TableCell align="right">
                                        <Button
                                            color="secondary"
                                            size="small"
                                            variant="contained"
                                            disabled={isRemovingFromRole}
                                            onClick={() => removeUserClickHandler(user)}>
                                            <DeleteIcon />
                                        </Button>
                                    </TableCell>
                                    :
                                    null
                                }
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </Hidden>
        </Paper>
    );
}